import React from 'react'
import { EstimateSummaryCard } from './EstimateSummaryCard'
import { EstimateStatisticsResponse } from '../../api/estimates/types/model'
import { CardsContainer } from './EstimateSummaryCards.styles'

interface EstimateSummaryCardsProps {
  statistics: EstimateStatisticsResponse
}

export const EstimateSummaryCards: React.FC<EstimateSummaryCardsProps> = ({
  statistics
}) => {
  return (
    <CardsContainer>
      <EstimateSummaryCard
        title="Подписано договоров"
        amount={statistics.totalByContracts}
        iconType="document"
        iconBgColor="#DBEAFE"
        color="#155DFC"
      />
      <EstimateSummaryCard
        title="В процессе согласования"
        amount={statistics.inApprovalProcess}
        iconType="check-document"
        iconBgColor="#DCFCE7"
        color="#00A63E"
      />
      <EstimateSummaryCard
        title="Итого по актам"
        amount={statistics.totalByActs}
        iconType="check-document"
        iconBgColor="#F3E8FF"
        color="#9810FA"
      />
      <EstimateSummaryCard
        title="Итого оплат"
        amount={statistics.totalPayments}
        iconType="dollar"
        iconBgColor="#FFEDD4"
        color="#F54900"
      />
    </CardsContainer>
  )
}
